import { createSvg } from '@r1-frontend/ui-kit/atoms/svg/createSvg';

const Check = (
    {
        strokeWidth = 1.5,
    },
): JSX.Element => {
    return (
        <g id={'guts'}>
            <path
                d='M6.30005 11.2L10.7 15.5L18.1 8.50002'
                strokeWidth={strokeWidth}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </g>
    );
};

export default createSvg(
    Check,
    'check',
);
